import { createSlice } from "@reduxjs/toolkit";

const fetchStoredValues = () => {
  // is Dark mode is stored as 1 or 0 for true or false

  const palette = localStorage.getItem("customPaletteNum");
  const isDarkMode = localStorage.getItem("isDarkMode");
  let item = {};

  if (isDarkMode != null) {
    item = {
      isDarkMode: JSON.parse(isDarkMode),
    };
  } else {
    // set the default
    item = {
      isDarkMode: false,
    };
  }

  if (palette != null) {
    return {
      ...item,
      palette: +palette,
    };
  } else {
    return {
      ...item,
      palette: 0,
    };
  }
};

const initialThemeState = {
  isDarkMode: fetchStoredValues().isDarkMode,
  customPaletteNum: fetchStoredValues().palette,
};

const themeSlice = createSlice({
  name: "theme",
  initialState: initialThemeState,
  reducers: {
    toggleTheme(state) {
      state.isDarkMode = !state.isDarkMode;
    },
    toggleCustomTheme(state, action) {
      console.log(action.payload);
      state.customPaletteNum = action.payload.customPaletteNum;
    },
  },
});

export default themeSlice.reducer;
export const themeActions = themeSlice.actions;
